module.exports = __webpack_public_path__ + "media/recipes/96-319d2be0.png";